import React, { useEffect, useRef } from "react";
import "../styles/ContactSection.css";

const ContactSection = () => {
  const formRef = useRef(null);

  useEffect(() => {
    // Create the script
    const script = document.createElement("script");
    script.src =
      "https://r3.minicrm.hu/api/loader.js?51354-1xqo62zevc16xr7oa3km143qm7299n";
    script.async = true;

    // Append into the form container
    if (formRef.current) {
      formRef.current.appendChild(script);
    }

    return () => {
      // Cleanup ONLY inside the container
      if (formRef.current?.contains(script)) {
        formRef.current.removeChild(script);
      }
    };
  }, []);

  return (
    <section className="contact-section" id="contact">
      <div className="contact-container">
        <h2 className="contact-title">
          Készen állsz változtatni és felépíteni a szabad életed?
          <br />
          <span>Jelentkezz most – kevesebb mint 2 perc az egész.</span>
        </h2>

        <div className="contact-form-wrapper">
          <div className="minicrm-form" ref={formRef}></div>
        </div>
      </div>
    </section>
  );
};

export default ContactSection;
